import React, {Component} from 'react';
import PieChart from 'react-minimal-pie-chart';
import PropTypes from 'prop-types';
import Maps from './Maps';
import parser from 'ua-parser-js';
import userImage from "../../assets/128x128.jpg";
import moment from 'moment';
import mac from '../../assets/img/devices/mac.jpg';
import windows from '../../assets/img/devices/windows.jpg';
import android from '../../assets/img/devices/android.jpg';
import iphone from '../../assets/img/devices/iphone.jpg';
import unknownDevice from '../../assets/img/devices/unknown-device.jpg';
import api from '../../utils/api';
import jQuery from 'jquery';
import {Link} from 'react-router-dom';
const $ = window && window.jQuery ? window.jQuery : jQuery;
const device = new parser();

class StudentProfile extends Component {
    state = {
        latitude: '',
        longitude: '',
        country_name: '',
        ip: ''
    };

    //Renders
    renderNamePage = () => {
        let p = null;
        if(this.props.courseUser.length > 0){
            p = this.props.courseUser[0].Profile;
        }
        if(p){
        return (
            <div className="bg-light lter b-b wrapper-md">
            <div className="row">
                <div className="col-sm-8 col-xs-12">
                    <h1 className="m-n font-thin h3 text-black">
                        {p.name} {p.lname} 
                    </h1>
                    <small className="text-muted">
                        {p.online ?
                            <i className="zmdi zmdi-circle text-success" title="Online now" />
                        : null}
                        &nbsp; 
                        Student Profile
                    </small>
                </div>
                <div className="col-sm-4 col-xs-12 text-right">
                    <div className="flex flex-align-items-center flex-justify-content-flex-end headerCallEmailBtns">

                        <div className="btn-group dropdown">
                            <button href="#" data-toggle="dropdown" className="btn btn-icon btn-round btn-success" aria-expanded="false"><i className="zmdi zmdi-phone"></i></button>
                            <ul className="dropdown-menu pull-right">
                                <li><a href={`tel:${p.phone}`}>+{p.phonecountry} {p.phone}</a></li>
                                
                            </ul>
                        </div>
                        <div className="btn-group dropdown">
                            <button href="#" data-toggle="dropdown" className="btn btn-icon btn-round btn-info" aria-expanded="false"><i className="zmdi zmdi-email"></i></button>
                            <ul className="dropdown-menu pull-right">
                                <li><a href={`mailto:${p.email}`}>{p.email}</a></li>
                                
                            </ul>
                        </div>

                    </div>
                </div>
            </div>
        </div>
            )
        }
    }
        
    

    renderHeaderLinks = () => (
        <ul className="nav nav-tabs bg-white">
            <li className="active">
                <a>
                    Overview
                    <span>General Details</span>
                </a>
            </li>
            
            {this.props.courseUser &&
            this.props.courseUser.length > 0 &&
                this.props.courseUser.map((cu, i) => {

                    if(cu.subjectOrder){
                        return (
                            <li>
                                {cu.Course &&
                                    <Link to={`/student-course/${cu.Profile ? cu.Profile.id : ''}/${cu.courseId}/${cu.subjectOrder[0]}`}>
                                        {cu.Course ? cu.Course.name : ''}
                                        <span>Course Details</span>
                                    </Link>
                                }
                            </li>
                        )       
                    }
                })
            }

        </ul>
    );

    renderCircumstancesNew = () => {

        let currentYear = new Date().getFullYear();
        let outOfSchool = currentYear - this.props.studentProfile.education[0].finishedDegreeDate;


        return (

            <div className="panel customPanel">
                <div className="panel-heading">
                    <h3 className="panel-title text-uppercase">Circumstances</h3>
                </div>
                <div className="panel-body no-padding">
                    <table className="table profile-info-table">
                        <tbody>
                            <tr>
                                <td>
                                    <p>Institution</p>
                                    <h3>{this.props.studentProfile.education[0].institution}</h3>
                                </td>

                            <td>
                                <p>Highest Level of Education</p>
                                <h3>{this.props.studentProfile.education[0].finishedDegree}</h3>
                            </td>
                            <td>
                                <p>Degree</p>
                                <h3>{this.props.studentProfile.education[0].finishedDegreeName || 'None'}</h3>
                            </td>
                            <td>
                                <p>Years of Study</p>
                                <h3>{this.props.studentProfile.education[0].yearOfStudy}</h3>
                            </td>

                            <td>
                                <p>Expected Completion Date</p>
                                <h3>{this.props.studentProfile.education[0].completionDate || 'N/A'}</h3>
                            </td>
                            </tr>
                            <tr>
                            <td>
                                <p>Age</p>
                                <h3>{currentYear - new Date(this.props.studentProfile.birthdate).getFullYear() || 'N/A'}</h3>
                            </td>
                            <td>
                                <p>Gender</p>
                                <h3>{this.props.studentProfile.gender}</h3>
                            </td>
                            <td>
                                <p>Children</p>
                                <h3>{this.props.studentProfile.personal.hasChildren || 'None'}</h3>
                            </td>
                            <td>
                                <p>Marital Status</p>
                                <h3>{this.props.studentProfile.personal.martialStatus}</h3>
                            </td>
                            <td>
                                <p>Disability</p>
                                <h3>{this.props.studentProfile.personal.hasDisabilities || 'None'}</h3>
                            </td>
                            </tr>
                            <tr>
                            <td>
                                <p>Employment Status</p>
                                <h3>{(this.props.studentProfile.personal.isEmployed) ? 'Employed' : 'Unemployed'}</h3>
                            </td>
                            {(this.props.studentProfile.personal.isEmployed) &&
                            <td>
                                <p>Hours per week</p>
                                <h3>{this.props.studentProfile.personal.workingHours}</h3>
                            </td>
                            }

                            <td>
                                <p>Years out of school</p>
                                <h3>{outOfSchool}</h3>
                            </td>

                            <td>
                                <p>GPA</p>
                                <h3>{this.props.studentProfile.education[0].userCGPA}</h3>
                            </td>
                            <td>
                                <p>University Majors</p>
                                <h3>{this.props.studentProfile.education[0].majorField || 'N/A'}</h3>
                            </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );


    }

    renderCircumstances = (circumstances) => (

        circumstances.map((item, index) => (
            <div className="panel customPanel" key={index}>
                <div className="panel-heading">
                    <h3 className="panel-title text-uppercase">{item.title}</h3>
                </div>
                <div className="panel-body no-padding">
                    <table className="table profile-info-table">
                        <tbody>
                            {this.renderTableCircumstances(item.items)}


                        </tbody>
                    </table>
                </div>
            </div>
        ))
    );
    
    getUserImage = () => {

        if(this.props.courseUser.length > 0) {
            if(this.props.courseUser[0].Profile){
            if(this.props.courseUser[0].Profile.image){
                return api.makeFileURL(this.props.courseUser[0].Profile.image, this.props.user.id);
            }else{
                return userImage;
            }
            }else{
               return userImage; 
            }

        }
    }

    renderTableCircumstances = (items) => {
        let i,j,temparray;
        let chunk = 5;
        let circumstances = [];

        for (i=0,j=items.length; i<j; i+=chunk) {
            temparray = items.slice(i,i+chunk);
            circumstances.push(temparray)
        }

        return circumstances.map((item,index)=> (
            <tr key={index}>
                {this.renderTableRow(item)}
            </tr>

        ))
    };

    renderTableRow = (items) => (
        items.map((item,index) => (
            <td key={index}>
                <p>{item.name}</p>
                <h3>{item.value}</h3>
            </td>
        ))
    );
    
    ToggleDiagnosticScores = (btn) => {
        $(btn.target).parents(".foundationDiagnosticDivision").find(".daignosticscores").stop().slideToggle();
        btn.preventDefault();
    }

    renderFoundations = (foundations) => (
        <div className="panel customPanel">
            <div className="panel-heading">
                <h3 className="panel-title text-uppercase">
                    Foundations
                </h3>
            </div>
            <div className="panel-body no-padding">
                <table className="table profile-info-table">
                    <tbody>
                    <tr>
                        {this.props.courseUser.map(cu => {
                            return (
                                <div className="foundationDiagnosticDivision" style={{background: "#2d2d2d"}}>
                                    {cu.officialTest &&
                                    <div className="sp-top0" onClick={e => this.ToggleDiagnosticScores(e)}>
                                        <table className="table profile-info-table" style={{border: "none !important"}}>
                                            <tbody><tr>
                                                <td style={{paddingLeft: "20px"}}>
                                                    <p>Course</p>
                                                    <h3 className="text-white">{cu.Course ? cu.Course.name : ''}</h3>
                                                </td>
                                                <td>
                                                    <p>Official Test Score</p>
                                                    <h3>{cu.officialTest.minScore}</h3>
                                                </td>
                                                
                                                <td style={{width: "40px"}} className="text-center">
                                                    <i className="zmdi zmdi-chevron-down font-30"></i>
                                                </td>
                                            </tr>
                                        </tbody></table>
                                    </div>
                                    }
                                    
                                    {cu.officialTest &&
                                    <div className="sm-top0 daignosticscores" style={{display: "none"}}>
                                        <div className="panel-heading" style={{background: "#2d2d2d"}}>
                                            <h3 className="panel-title text-uppercase">Diagnostic Scores</h3>
                                        </div>
                                        <div className="clearfix diagnostic-score-wrapper">
                                            <div className="one-fifth text-center sp-20 diagnostic-score sectionsScore">
                                                <p>Sections</p>
                                            </div>
                                            {cu.officialTest.sections.map(s => {
                                                return (
                                                
                
                
                                                    <div className="one-fifth text-center sp-20 diagnostic-score">
                                                        <p>{s.name}</p>
                                                        <PieChart
                                                            style={{width: 100, margin: '0 auto'}}
                                                            data={[
                                                                {value: s.minScore, color: '#e3d9d8'},
                                                                {value: s.minScore, color: '#e33339'}
                                                            ]}
                                                            totalValue={s.maxScore}
                                                            lineWidth={20}
                                                            rounded={true}
                                                        />
                                                        <p className="diagnostic-pie-chart-counter">{s.minScore}/{s.maxScore}</p>
                                                    </div>    
                                                )
                                            })
                                            }
                                            
                                            
                                        </div>

                                    </div>
                                    }
                                </div>
                            )
                        })
                            
                            
                        }
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );

    renderFoundationsTable = (foundations) => {

        if(foundations){
            let fk = Object.keys(foundations);
            let fkNames = {
                tokeLSAT: "Took LSAT",
                testDate: "Date",
                testScore: "Score",
                logicScore: "LR",
                analyticScore: "AR",
                readingScore: "R"
            }

            return fk.map((item, index) => (
                <td key={index}>
                    <p>{fkNames[item]}</p>
                    <h3>{foundations[item]}</h3>
                </td>
            ))
        }

    };

    renderDiagnostic = (diagnosticScore) => (
        <div className="panel customPanel">
            <div className="panel-heading">
                <h3 className="panel-title text-uppercase">
                    Diagnostic Score
                </h3>
            </div>
            {this.props.studentProfile.CourseUser &&
            <div className="panel-body no-padding">
                <div className="clearfix diagnostic-score-wrapper">
                    {this.renderDiagnosticScore(this.props.studentProfile.CourseUser[0].UserTest)}
                </div>
            </div>
            }
        </div>
    );

    renderDiagnosticScore = (diagnosticScore) => {
        if(diagnosticScore[0]) {
            return diagnosticScore[0].concepts.map((item, index) => (
                <div
                    className="one-fifth text-center sp-20 diagnostic-score diagnostic-pie-chart"
                    key={index}
                >
                    <p>{item.name}</p>
                    <PieChart
                        style={{width: 100, margin: '0 auto'}}
                        data={[
                            {value: item.correctPercent, color: '#e3d9d8'},
                            {value: item.correctAnswers, color: '#e33339'}
                        ]}
                        totalValue={item.questionCount}
                        lineWidth={20}
                        rounded={true}
                    />
                    <p className="diagnostic-pie-chart-counter">{item.correctAnswers}/{item.questionCount}</p>
                </div>
            ))
        }
    }



    renderLogInformation = (logInfo, markers) => (
        <div className="panel customPanel">
            <div className="panel-heading">
                <h3 className="panel-title text-uppercase">
                    Log In Information
                </h3>
            </div>
            <div className="panel-body no-padding">
                <div className="row no-margin">
                    <div className="col-sm-7 no-padding">
                        <table className="table">
                            <tbody>
                            {this.renderTableLogInformation(logInfo)}
                            </tbody>
                        </table>
                    </div>
                    <div className="col-sm-5 no-padding">
                        <div id="locationMap">
                            <Maps
                                markers={logInfo.filter(l => { return l.location })}
                                type='edit'
                                getPositionOnMap={this.getPositionOnMap}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    renderTableLogInformation = (logInfo) => {

        logInfo = logInfo.filter(l => l.hasOwnProperty("browser"));

        let logins = [];

        logInfo.map(login => {
            let b = 'Other';
            let os = 'Unknown Operating System';
            let img = 'unknown-device.jpg';

            if(login.browser.indexOf('Firefox') > -1){
                b = "Firefox";
            }else if(login.browser.indexOf('Chrome') > -1){
                b = "Chrome";
            }else if(login.browser.indexOf('Safari') > -1){
                b = "Safari";
            }else if(login.browser.indexOf('IE') > -1){
                b = "Internet Explorer";
            }else if(login.browser.indexOf('Edge') > -1){
                b = "Microsoft Edge";
            }else if(login.browser.indexOf('Opera') > -1){
                b = "Opera";
            }else if(login.browser.indexOf('Vivaldi') > -1){
                b = "Vivaldi";
            }

            if(login.browser.toLowerCase().indexOf('win') > -1){
                os = "Windows";
                img = windows;
            }else if(login.browser.toLowerCase().indexOf('android') > -1){
                os = "Android";
                img = android;
            }else if(login.browser.toLowerCase().indexOf('mac') > -1){
                os = "macOS";
                img = mac;
            }else if(login.browser.toLowerCase().indexOf('ios') > -1){
                os = "iOS";
                img = iphone;
            }else if(login.browser.toLowerCase().indexOf('linux') > -1){
                os = "Linux";
                img = unknownDevice;
            }

            let l = {...login, b: b, count: 1, os: os, img: img};


            let existingIndex = [];

            logins.map((log, i) => {
                if(log.b === b && log.ip === login.ip){
                    existingIndex.push(i);
                }
                 return true;
            });

            if(existingIndex.length > 0){
                logins[existingIndex[0]].count += 1;
            }else{
                logins.push(l);
            }
             return true;
        });

        return logins.map((item, index) => (
            <tr key={index}>
                <td style={{width: 50}}>
                    <img src={item.img} alt={item.img}/>
                </td>
                <td>
                    <h4 className="device-location">{`${item.os}${(item.location ? ',' + item.location.regionName : '')}`}</h4>
                    <p className="browsing-info"><span>{item.b}</span> - {moment(new Date(item.created)).fromNow()}</p>
                </td>
                <td>{item.ip}</td>
                <td>{item.count} times</td>
            </tr>
        ))
    }

    renderStudentInfo = (studentInfo) => (
        <div className="panel customPanel">
            <div className="panel-body">
                <div className="row">
                    <div className="col-sm-2">
                        <img
                            className="thumbnail"
                            src={this.getUserImage()}
                            alt="user"
                        />
                    </div>
                    <div className="col-sm-10">
                        <div className="student-info-table">
                            <div className="row">
                                {this.renderStudentInfoContent('col-sm-4', 'Name', studentInfo.name)}
                                {this.renderStudentInfoContent('col-sm-4', 'Phone Number', studentInfo.phone)}
                                {this.renderStudentInfoContent('col-sm-4', 'Email Address', studentInfo.email)}
                            </div>
                            <div className="row">
                                {this.renderStudentInfoContent('col-sm-4', 'Street', studentInfo.address1)}
                                {this.renderStudentInfoContent('col-sm-2', 'City', studentInfo.city)}
                                {this.renderStudentInfoContent('col-sm-2', 'Province', studentInfo.district)}
                                {this.renderStudentInfoContent('col-sm-2', 'Country', studentInfo.country)}
                                {this.renderStudentInfoContent('col-sm-2', 'Postal Code', studentInfo.postalCode)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    renderStudentInfoContent = (className, title, value) => (
        <div className={className}>
            <p>
                {title}
            </p>
            <h3>
                {value}
            </h3>
        </div>
    );

    renderAccordions = (accordionStatistic) => (
        accordionStatistic.map((item, index) => (
            <div className="panel" key={index}>
                <div className="panel-heading border-bottom">
                    <h3 className="panel-title">
                        <a
                            data-parent="#accordion"
                            className="font-400"
                            data-toggle="collapse"
                            href={"#"+item.link}
                        >
                            <i className={"zmdi zmdi-"+item.font_image}/>
                            {item.title}
                        </a>
                    </h3>
                </div>
                <div
                    className={"panel-collapse collapse "+ (+index === 0
                        ? "in"
                        : ''
                    )}
                    id={item.link}
                >
                    <div className="panel-body">
                        <ul className="list-with-label">
                            {this.renderAccordionStatistic(item.items)}
                        </ul>
                    </div>
                </div>
            </div>
        ))
    );

    renderAccordionStatistic = (statistic) => (
        statistic.map((item, index) => {

             if (item.name.length !==0) {
                 return(
                     <li key={index}>
                         <span className="list-text">
                             {item.name}
                         </span>
                         <span className="label label-info">
                             {item.value}
                         </span>
                     </li>
                 );
             } else {
                 return (
                     <h2
                         key={index}
                         style={{textAlign: "center"}}
                     >
                         {item.value}
                     </h2>
                 );
             }

        })
    );

    //Actions
    getPositionOnMap = ({lat, lng}) => {
        this.setState({
            latitude: lat,
            longitude: lng
        })
    };

    getDevice() {
        this.setState({
            browser: device.getBrowser().name,
            os: device.getOS().name
        })
    };

    getTimeUser() {
        let date = new Date();
        this.setState({
            date: date.toLocaleDateString('en-US', { day: 'numeric' , year: 'numeric', month: 'long' }),
            time: date.getHours()+':'+date.getMinutes()
        })
    };
    
    renderRightSide = () => {
        return (
            <div className="col-sm-3 sp-left0">
                    <div className="panel-group accordion sm-top20 sp-right10" id="accordion">
                        <div className="panel no-bg">

                           
                            <div className="panel-heading bg-light-3">
                                <h3 className="panel-title">
                                    <a data-parent="#accordion" className="font-400 collapsed" data-toggle="collapse" href="#collapseOne" aria-expanded="false"><i className="zmdi zmdi-time-interval"></i> Deadlines Missed</a>
                                </h3>
                            </div>

                           
                            <div className="panel-collapse collapse" id="collapseOne" aria-expanded="false" style={{height: "0px"}}>
                                <div className="panel-body">
                                    <ul className="list-with-label">
                                        {this.props.courseUser.map(cu => {
                                            if(cu.Course){
                                               return (
                                                        <li>
                                                            <span className="list-text">{cu.Course ? cu.Course.name : ''}</span> <span className="label label-info">{cu.Flags ? cu.Flags.filter(f => f.id === 1).length : 0}</span>
                                                        </li>    
                                                    )
                                                }
                                                else{
                                                    return null;
                                                }
                                            })
                                            
                                        }

                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="panel no-bg">

                            
                            <div className="panel-heading bg-light-3">
                                <h4 className="panel-title">
                                    <a data-parent="#accordion" data-toggle="collapse" href="#collapseTwo" className="collapsed" aria-expanded="false"><i className="zmdi zmdi-star"></i> Merits Earned</a>
                                </h4>
                            </div>

                           
                            <div className="panel-collapse collapse" id="collapseTwo" aria-expanded="false" style={{height: "0px"}}>
                                <div className="panel-body">
                                    <ul className="list-with-label">
                                        {this.props.courseUser.map(cu => {
                                            if(cu.Course){
                                        
                                                let merits = 0;
                                                    cu.UserLecture.map(p => {
                                                        if(p.points){
                                                            merits += p.totalPoints;
                                                        }
                                                        return true;
                                                    })
                                                   return (
                                                            <li>
                                                                <span className="list-text">{cu.Course.name}</span> <span className="label label-info">{merits}</span>
                                                            </li>    
                                                        )
                                                }else{
                                                    return null;
                                                }
                                                })
                                            }
                                        
                                      
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="panel no-bg">

                           
                            <div className="panel-heading bg-light-3">
                                <h4 className="panel-title">
                                    <a data-parent="#accordion" data-toggle="collapse" href="#collapseThree" className="collapsed" aria-expanded="false"><i className="zmdi zmdi-badge-check"></i> Global Rank</a>
                                </h4>
                            </div>

                            
                            <div className="panel-collapse collapse" id="collapseThree" aria-expanded="false" style={{height: "0px"}}>
                                <div className="panel-body">
                                    <p className="font-40 text-center sp-top-bottom20">14</p>
                                </div>
                            </div>
                        </div>
                        <div className="panel no-bg">

                            
                            <div className="panel-heading bg-light-3">
                                <h4 className="panel-title">
                                    <a data-parent="#accordion" data-toggle="collapse" href="#collapseFour" className="" aria-expanded="true"><i className="zmdi zmdi-alert-triangle"></i> Warnings Given</a>
                                </h4>
                            </div>

                            
                            <div className="panel-collapse collapse in" id="collapseFour" aria-expanded="true" >
                                <div className="panel-body">
                                    <ul className="warnings-list">
                                        {this.props.courseUser.map(cu => {
                                            if(cu.Flags){
                                                return (
                                                    <li>
                                                        <div className="flex flex-justify-content-space-between" onClick={e => this.ToggleWarningsBox(e.target)}>
                                                        <span className="list-text"><i className="zmdi zmdi-chevron-right font-16"></i> {this.props.course ? this.props.course.name : ''}</span> 
                                                        <span className="label label-info">{cu.Flags.length}</span></div>
                                                        <div style={{display: "none"}} className="warnings_subject_box">
                                                            <ul className="half-aligned-list">
                                                                <li>
                                                                    <span className="span-left"><i className="zmdi zmdi-flag" style={{color: "#e84a5f"}}></i> Red Flags</span>
                                                                    <span className="span-right"><a href="red-flags.php"> {cu.Flags.filter(f => f.type === 'red').length}</a></span>
                                                                </li>
                                                                <li>
                                                                    <span className="span-left"><i className="zmdi zmdi-flag" style={{color: "#ff847c"}}></i> Orange Flags</span>
                                                                    <span className="span-right">{cu.Flags.filter(f => f.type === 'orange').length}</span>
                                                                </li>
                                                                <li>
                                                                    <span className="span-left"><i className="zmdi zmdi-flag" style={{color: "#f7d969"}}></i> Yellow Flags</span>
                                                                    <span className="span-right">{cu.Flags.filter(f => f.type === 'yellow').length}</span>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </li>
                                                )
                                            }else{ 
                                                return (
                                                    <li>
                                                        <div className="flex flex-justify-content-space-between" onClick={e => this.ToggleWarningsBox(e.target)}>
                                                        <span className="list-text"><i className="zmdi zmdi-chevron-right font-16"></i> {this.props.course ? this.props.course.name : ''}</span> 
                                                        <span className="label label-info">0</span></div>
                                                        <div style={{display: "none"}} className="warnings_subject_box">
                                                            <ul className="half-aligned-list">
                                                                <li>
                                                                    <span className="span-left"><i className="zmdi zmdi-flag" style={{color: "#e84a5f"}}></i> Red Flags</span>
                                                                    <span className="span-right"><a href="red-flags.php"> 0</a></span>
                                                                </li>
                                                                <li>
                                                                    <span className="span-left"><i className="zmdi zmdi-flag" style={{color: "#ff847c"}}></i> Orange Flags</span>
                                                                    <span className="span-right"> 0</span>
                                                                </li>
                                                                <li>
                                                                    <span className="span-left"><i className="zmdi zmdi-flag" style={{color: "#f7d969"}}></i> Yellow Flags</span>
                                                                    <span className="span-right"> 0</span>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </li>
                                                )
                                            }
                                        })
                                        
                                        }
                                        
                                     
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>    
        )
    }
    
    ToggleWarningsBox = (btn) => {
        $(".warnings_subject_box").slideUp();
        $(btn).parents("ul").find("i.zmdi-chevron-down").removeClass("zmdi-chevron-down").addClass("zmdi-chevron-right");
        $(btn).parents("li").find(".warnings_subject_box").slideDown();
        $(btn).find("i").removeClass("zmdi-chevron-right").addClass("zmdi-chevron-down");
    }

    //Lifecycle
    componentDidMount() {
        if(this.props.match.params.id) {
            this.props.getStudentProfile(this.props.match.params.id, this.props.user.id);
        }
        this.getDevice();
        this.getTimeUser();
        this.props.getLogins(this.props.user.user, this.props.user.id);
    };

    componentWillUpdate(nextProps){
        if(nextProps.studentProfile !== this.props.studentProfile){
            if(!this.props.logins){
                this.props.getLogins(nextProps.studentProfile.user, this.props.user.id);
            }
        }
    }

    render() {
        const {studentProfile} = this.props;


        if(!studentProfile.id || this.props.courseUser.length === 0 || !this.props.courseUser[0].id){
            return (
                <div className="loader">
                    <div className="sk-folding-cube">
                        <div className="sk-cube1 sk-cube"></div>
                        <div className="sk-cube2 sk-cube"></div>
                        <div className="sk-cube4 sk-cube"></div>
                        <div className="sk-cube3 sk-cube"></div>
                    </div>
                </div>
            )
        }

        return(
            <div className="content-wrapper" id="content-container">
                {this.renderNamePage()}
                <section className="content no-padding">
                    <div className="row">
                        <div className="col-sm-9">
                            <div className="nav-tabs-custom no-bg">
                                {this.renderHeaderLinks()}
                                <div className="tab-content no-bg no-padding">
                                    <div className="tab-pane active" id="tab_1">
                                        {
                                            this.props.studentProfile &&
                                            this.renderStudentInfo(this.props.studentProfile)
                                        }
                                        <div style={{paddingLeft: 10}}>
                                            {
                                                this.props.studentProfile &&
                                                this.renderCircumstancesNew()
                                            }
                                            {
                                                this.props.studentProfile.onboardingTest &&
                                                this.renderFoundations(this.props.studentProfile.onboardingTest)
                                            }
                                     
                                            {
                                                this.props.logins &&
                                                this.renderLogInformation(this.props.logins, studentProfile.markersMap)
                                            }

                                        </div>
                                    </div>
                                    <div
                                        className="tab-pane"
                                        id="tab_2"
                                    >
                                    </div>
                                </div>
                            </div>
                        </div>
                        {this.renderRightSide()}
                        <div className="col-sm-3">
                            <br /><br /><br />
                            <div
                                className="panel-group accordion"
                                id="accordion"
                            >
                                {
                                    studentProfile.accordionStatistic &&
                                    this.renderAccordions(this.props.studentProfile.accordionStatistic)
                                }
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

StudentProfile.propTypes = {
    studentProfile: PropTypes.shape({
        studentInfo: PropTypes.object,
        circumstances: PropTypes.array,
        foundations: PropTypes.array,
        diagnosticScore: PropTypes.array,
        markersMap: PropTypes.array,
        accordionStatistic: PropTypes.array,
        logInfo: PropTypes.array
    })
};

export default StudentProfile;


// WEBPACK FOOTER //
// ./src/components/StudentProfile/StudentProfile.js